import urljoin from 'url-join';
import Request from './Request';

/**
 * Provides an easy way of making a request via an API base path.
 */
export default class AdminRequest extends Request {
	constructor(uri, options) {
		super(options);
		this.uri = uri;
	}

	_op(verb, uri, data, params, headers, cancelToken) {
		const path = urljoin(window.location.origin, window.$conf.apiprefix, uri);
		return super.invoke(verb, path, data, params, null, headers, cancelToken);
	}
}
